import lodash from 'lodash-es'
import axios from 'axios'
import { SET_REGISTRATIONS, SET_FILTRED_REGISTRATIONS } from '../mutation-types'
const registrations = {
  namespaced: true,
  state: {
    registrations: [],
    filtredRegistrations: [],
    pagination: {},
    limit: 15,
    filterCourses: [],
  },
  mutations: {
    [SET_REGISTRATIONS](state, data) {
      console.log('data SET_REGISTRATIONS = ', data)
      state.registrations = data.data
      state.pagination = lodash.get(data, 'meta.pagination', {})
      state.filterCourses = lodash.get(data, 'meta.courses', [])
    },
    [SET_FILTRED_REGISTRATIONS](state, data) {
      state.filtredRegistrations = data
    },
  },
  actions: {
    filterRegistrations({ commit, rootState }, { params = {} }) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return new Promise((resolve, reject) => {
        axios
          .post(
            rootState.apiBaseURL + '/registrations/' + rootState.user.id,
            params
          )
          .then((response) => {
            let resp = []
            if (lodash.get(response, 'data.data')) {
              resp = response.data.data
              commit('SET_FILTRED_REGISTRATIONS', resp)
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    searchRegistrations({ commit, rootState }, { params = {} }) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return new Promise((resolve, reject) => {
        axios
          .post(
            rootState.apiBaseURL + '/registrations/' + rootState.user.id,
            data,
            {
              params,
            }
          )
          .then((response) => {
            let resp = []
            console.log('response = ', response)
            if (lodash.get(response, 'data.data')) {
              resp = response.data.data
              let data = response.data.data
              let meta = response.data.meta
              commit('SET_REGISTRATIONS', { data: data, meta: meta })
              commit('SET_FILTRED_REGISTRATIONS', resp)
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getRegistrationsByClientId({ commit, state, rootState }, params = {}) {
      console.log('reseved params', params)
      let payload = {}
      payload.companyId = lodash.get(rootState, 'company.id', null)
      payload.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return axios
        .post(
          rootState.apiBaseURL + '/registrations/' + rootState.user.id,
          payload,
          { params }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            let meta = response.data.meta
            commit('SET_REGISTRATIONS', { data: data, meta: meta })
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    getTrainings({ commit, state, rootState }, params = {}) {
      return axios
        .get(
          rootState.apiBaseURL +
            '/courses-by-registrations/' +
            rootState.user.id
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
  },
  getters: {},
}
export default registrations
